import React, { Component } from 'react';

import { Row, Col, Collapse } from "antd";

class RuleBook extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <Row>

            </Row>);
    }
}

export default RuleBook;